/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&name=RecordList&setup=true&lang=js"
export * from "./index.vue?vue&type=script&name=RecordList&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=7a831eb5&lang=scss"

const __exports__ = script;

export default __exports__